"use client";

import moment from "moment";
import { MdOutlineFaceUnlock } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

export default function DataTable({ tableData }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleViewClick = (row) => {
    const basePath = location.pathname.includes("/agent/client-history")
      ? "/agent/client-history"
      : "/admin/client-history";

    navigate(`${basePath}/${row._id}`, { state: { row } });
  };

  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <table className="w-full text-nowrap">
          <thead>
            <tr className="text-left">
              <th className="p-3 font-normal">Name</th>
              <th className="p-3 font-normal">Date</th>
              <th className="p-3 font-normal">Country</th>
              <th className="p-3 font-normal">Inquiry Type</th>
              <th className="p-3 font-normal">Visa Type</th>
              <th className="p-3 font-normal">Agent</th>
              <th className="p-3 font-normal">Status</th>
              <th className="p-3 font-normal">Client Data</th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((row, index) => (
              <tr
                key={row._id}
                className={`text-white ${
                  index % 2 === 0 ? "bg-[#005787]" : "bg-[#036494]"
                }`}
              >
                <td className="p-3 flex items-center gap-3">
                  <div className="p-1 bg-white rounded-full flex items-center justify-center text-black">
                    <MdOutlineFaceUnlock size={40} />
                  </div>
                  <div>
                    <div>{row.firstName + " " + row.lastName}</div>
                    <div className="text-xs opacity-75">{row.uniqueId}</div>
                  </div>
                </td>
                <td className="p-3">
                  {moment(row.createdAt).format("DD/MM/YY")}
                </td>
                <td className="p-3">{row.countryOfInterest}</td>
                <td className="p-3">{row.inquiryType}</td>
                <td className="p-3">
                  <div className="bg-white w-full text-[#0c4a6e] px-3 py-1 rounded-full text-sm inline-flex items-center gap-1">
                    {row.visaCategory}
                  </div>
                </td>
                <td className="p-3">
                  <div
                    className={`bg-white w-full px-3 h-[28px] py-1 rounded-full text-sm inline-flex items-center gap-1 ${
                      row.agent ? "text-[#0c4a6e]" : "text-red-500"
                    }`}
                  >
                    {row.agent
                      ? row.agent.firstName + " " + row.agent.lastName
                      : "Un-Assigned"}
                  </div>
                </td>
                <td className="p-3">
                  <div className="bg-white text-[#0c4a6e] px-3 py-1 rounded text-sm inline-flex items-center">
                    <>
                      {row?.status === "WithdrawnByClient" || row?.status === "Cancelled"
                        ? "Cancelled"
                        : row?.status === "WithdrawnByAgent"
                          ? "Withdrawn"
                          : row?.status || "N/A"}
                    </>

                  </div>
                </td>
                <td className="p-3">
                  <button
                    onClick={() => handleViewClick(row)}
                    className="bg-white text-[#0c4a6e] px-4 py-1 rounded hover:bg-blue-50 transition-colors"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
